import type { ComponentProps } from "react";

const BoxIcon = (props: ComponentProps<"svg">) => {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.3642 1.70248C9.1377 1.57663 8.8623 1.57663 8.6358 1.70248L3.12376 4.7647L9.01185 8.34876L15.1451 4.91409L9.3642 1.70248ZM15.75 5.86475L9.5625 9.32976V16.1876L15.3642 12.9644C15.6023 12.8322 15.75 12.5812 15.75 12.3088V5.86475ZM8.4375 16.1876V9.31618L2.25 5.54988V12.3088C2.25 12.5812 2.39767 12.8322 2.63577 12.9644L8.4375 16.1876Z"
        fill="#7D7D7D"
      />
    </svg>
  );
};

export default BoxIcon;
